import { render, staticRenderFns } from "./TransceiverStaff.vue?vue&type=template&id=6893d1b0&"
import script from "./TransceiverStaff.vue?vue&type=script&lang=js&"
export * from "./TransceiverStaff.vue?vue&type=script&lang=js&"
import style0 from "./TransceiverStaff.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports